"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneInboundSolidIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _SvgIcon = require("../SvgIcon");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
} /**
  * This file was generated by the build:icons script
  * See Notion for details on how to add icons
  */
const PhoneInboundSolidIcon = props => /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, _extends({}, props, {
  viewBox: "0 0 24 24"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.788 5.066 15.43 6.422H20.5a.8.8 0 1 1 0 1.6h-5.069l1.357 1.357a.8.8 0 0 1-1.132 1.131l-2.72-2.72a.796.796 0 0 1-.002-1.133l2.722-2.723a.8.8 0 0 1 1.132 1.132ZM7.228 4.01 4.703 4a1.7 1.7 0 0 0-.98.313c-.392.28-.654.74-.652 1.32l-.001.111c-.008.44-.028 1.678.446 3.32.525 1.814 1.643 4.097 3.984 6.438 3.744 3.743 8.047 4.535 9.91 4.428a1.7 1.7 0 0 0 .94-.312c.391-.281.653-.741.651-1.32l-.01-2.524c-.002-.825-.683-1.349-1.291-1.57-.295-.107-.807-.223-1.245-.322l-.08-.018c-.516-.117-.968-.222-1.224-.308-.623-.21-1.158-.022-1.566.253-.31.209-.632.525-.94.835-.138-.031-.36-.123-.66-.31-.62-.383-1.305-.995-1.814-1.504-.443-.444-1.05-1.142-1.448-1.787-.193-.314-.299-.556-.338-.713.177-.178.328-.33.45-.46a3.14 3.14 0 0 0 .405-.517c.264-.441.26-.854.258-1.133v-.054c-.002-.408-.15-1.013-.277-1.475a25.993 25.993 0 0 0-.416-1.367c-.226-.67-.792-1.311-1.577-1.314Z"
}));
exports.PhoneInboundSolidIcon = PhoneInboundSolidIcon;